(function() {
    // implement a simple caching so as to not fire multiple requests
    // for places which we've already fetched from the google API
    // and only pay them absolute minimum for fewest requests possible
    const placesCache = {};

    // quickly parse out the store lat/lng coords for the markers
    const locations = window.HOVER_STORES && window.HOVER_STORES.map(store => {
        return {
            lat: store.map.lat,
            lng: store.map.lng
        }
    });

    // keep track of the active origin / user location
    let originPoint = {};

    async function initMap() {
        // Request needed libraries.
        const { Map, InfoWindow } = await google.maps.importLibrary('maps');
        const { Place } = await google.maps.importLibrary('places');
        const { AdvancedMarkerElement } = await google.maps.importLibrary(
            'marker',
        );

        const mapWrap = document.querySelector('.map-wrap')
        const inputField = document.querySelector('.map__search input');
        const inputSearch = document.querySelector('.map__search button');
        const geolocateBtn = document.getElementById('map-geolocate');

        const parser = new DOMParser();
        const pinSvgString = `
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" class="map-pin">
            <path fill="#fff" d="M15.395 12.576h9.212v9.212h-9.212z"/>
            <path d="M20 3.602c-7 0-13.333 5.367-13.333 13.667 0 5.3 4.083 11.533 12.233 18.716.634.55 1.584.55 2.217 0C29.25 28.802 33.334 22.57 33.334 17.27 33.334 8.969 27 3.602 20 3.602Zm0 16.667a3.343 3.343 0 0 1-3.333-3.334c0-1.833 1.5-3.333 3.333-3.333 1.834 0 3.334 1.5 3.334 3.333 0 1.834-1.5 3.334-3.334 3.334Z" fill="#1DA3B9"/>
        </svg>`;

        // a list of strings for "hard to reach places" by the powers of PHP
        const translations = {
            directions: mapWrap.getAttribute('data-translation-directions')
        }

        // keep track of the active popup so we can dismiss it
        // when another one is opened
        let openInfoWindow = null;

        const map = new google.maps.Map(document.getElementById('map'), {
            zoom: 3,
            center: { lat: -28.024, lng: 140.887 },
            mapId: '6fb4fe201e75bc7d',
            gestureHandling: 'cooperative'
        });

        const bounds = new google.maps.LatLngBounds();

        // Add some markers to the map.
        const markers = locations.map((position, i) => {
            const store = window.HOVER_STORES[i];

            const pinSvg = parser.parseFromString(
                pinSvgString, 'image/svg+xml'
            ).documentElement;

            const marker = new google.maps.marker.AdvancedMarkerElement({
                position,
                content: pinSvg,
            });

            const infoWindow = new google.maps.InfoWindow({
                content: ''
            });

            // extend the bounds to include position
            bounds.extend(marker.position);

            // markers can only be keyboard focusable when they have click listeners
            // open info window when marker is clicked
            marker.addListener('click', async () => {
                openInfoWindow && openInfoWindow.close();
                openInfoWindow = infoWindow;
                const apiDetails = await getPlaceDetailsFromId(store.map.place_id)
                infoWindow.setContent(`
                    <div class="map-popup">
                        <h4>
                            ${store.website || apiDetails.website
                                ? `
                                <a href="${store.website || apiDetails.website}" target="_blank">
                                    ${store.name}
                                </a>
                                `
                                : store.name
                            }
                        </h4>
                        <p>
                            ${store.map.street_number} ${store.map.street_name}<br>
                            ${store.map.city}, ${store.map.state_short}<br>
                            ${store.map.post_code}<br>
                            ${store.phone || apiDetails.phone}
                        </p>
                        <a href="https://www.google.com/maps/place/?q=place_id:${store.map.place_id}" target="_blank" rel="noreferrer noopener">
                            ${translations.directions}
                        </a>
                    </div>
                `);
                infoWindow.open(map, marker);
            });

            return marker;
        });

        // fit the map to the newly inclusive bounds
        map.fitBounds(bounds);

        // custom style for the cluster pins
        const renderer = {
            render: ({ count, position }) =>
                new google.maps.Marker({
                    label: {
                        text: String(count),
                        color: 'white',
                        fontSize: '16px'
                    },
                    icon: {
                        path: google.maps.SymbolPath.CIRCLE,
                        scale: 10,
                        fillColor: '#004851',
                        strokeColor: '#004851',
                        strokeOpacity: 1,
                        fillOpacity: 1,
                    },
                    position,
                    // adjust zIndex to be above other markers
                    zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
                })
        };

        // Add a marker clusterer to manage the markers.
        const markerCluster = new markerClusterer.MarkerClusterer({
            map,
            markers,
            renderer
        });

        // initialize the autocomplete
        const input = document.getElementById('map-autocomplete');
        const options = {
            bounds,
            componentRestrictions: { country: ['ca'] },
            fields: ['formatted_address', 'geometry'],
            types: ['geocode'],
            strictBounds: false,
        };

        const autocomplete = new google.maps.places.Autocomplete(input, options);
        autocomplete.addListener('place_changed', () => {
            const place = autocomplete.getPlace()

            // user entered the name of a Place that was not suggested and
            // pressed the Enter key, or the Place Details request failed.
            if (!place.geometry || !place.geometry.location) {
                return;
            }

            updateOriginPoint(map, {
                lat: place.geometry.location.lat(),
                lng: place.geometry.location.lng(),
            });

            displayNearbyStores(map);
        });

        // handle input / search button events
        inputField.addEventListener('keydown', e => {
            if (e.code === 'Enter') {
                // console.log('autocomplete', autocomplete.getPlace());
            }
        });

        inputSearch.addEventListener('click', e => {
            // console.log('search clicked');
        });

        geolocateBtn.addEventListener('click', onGeolocateClick.bind(
            this, map, geolocateBtn
        ));

        // hit google up for additional details on the store
        // only fetch website and phone number
        // since fetching all fields is charged extra lulz
        async function getPlaceDetailsFromId(placeId) {
            if (placesCache[placeId] !== undefined) {
                return placesCache[placeId];
            }

            // if not found in the cache, fire the request
            const fetchDetails = () => {
                return new Promise((res, rej) => {
                    const service = new google.maps.places.PlacesService(map);
                    service.getDetails({
                        placeId,
                        fields: ['website', 'formatted_phone_number']
                    }, (place, status) => {
                        res({
                            website: place.website,
                            phone: place.formatted_phone_number
                        });
                    })
                });
            }

            const details = await fetchDetails();

            // add the entry to the cache
            placesCache[placeId] = details;

            return details;
        }
    }

    // init map if the element is present
    // and if the global HOVER_STORES object exists
    document.getElementById('map') && window.HOVER_STORES && initMap();

    // hanlde Geolocate button click event by fetching geolocation
    // and centering/zooming the map to the user's location
    // or showing an error button state if declined
    function onGeolocateClick(map, geolocateBtn) {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(position => {
                map.setCenter({
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                });
                map.setZoom(17);

                updateOriginPoint(map, {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                });

                displayNearbyStores(map);

            }, handleError);
        } else {
            handleError();
        }

        function handleError() {
            geolocateBtn.disabled = true;
            geolocateBtn.classList.add('btn--error');

            setTimeout(() => {
                geolocateBtn.classList.remove('btn--error');
                geolocateBtn.disabled = false;
                geolocateBtn.blur();
            }, 1000)
        }
    }

    // find out what the nearest stores are based on user location
    // provided by geolocation or from the places autocomplete dropdown
    async function displayNearbyStores(map) {
        const bounds = new google.maps.LatLngBounds();
        const service = new google.maps.DistanceMatrixService();
        const origins = [originPoint.location];
        const destinations = locations;

        // Google's API request limit
        const API_LIMIT = 25
        const destinationChunkSteps = Math.ceil(destinations.length / API_LIMIT)
        let distances = []

        for (let i = 0; i < destinationChunkSteps; i++) {
            const chunk = destinations.slice(i * 25, (i + 1) * 25);
            const chunkDistances = await getChunkDistance(chunk)
            distances = [...distances, ...chunkDistances]
        }

        // figure out what the closest stores are
        const closestStores = findClosestStores(distances)

        // extend map bounds with origin point and closest stores
        bounds.extend(originPoint.location);
        for (let i = 0; i < closestStores.length; i++) {
            const coords = {
                lat: closestStores[i].store.map.lat,
                lng: closestStores[i].store.map.lng
            }
            bounds.extend(coords);
        }

        // fit the bounds and make sure markers
        // aren't overlapping with the map controls
        // by adding zooming out a wee bit
        map.fitBounds(bounds);
        map.setZoom(map.getZoom() - 0.1);

        function getChunkDistance(destinations) {
            const request = {
                origins,
                destinations,
                travelMode: google.maps.TravelMode.DRIVING,
                unitSystem: google.maps.UnitSystem.METRIC,
                avoidHighways: false,
                avoidTolls: false,
            };

            return new Promise((res, rej) => {
                // calculate the distance between origin and all destinations
                service.getDistanceMatrix(request).then(response => {
                    res(response.rows[0].elements);
                });
            })
        }
    }

    function updateOriginPoint(map, position) {
        // remove the previous origin point marker from the map
        if (originPoint.marker) {
            originPoint.marker.map = null
        }

        // and set the new one
        originPoint = {
            location: position,
            marker: new google.maps.marker.AdvancedMarkerElement({
                map,
                position
            })
        };
    }

    // return only 3 nearest store results
    function findClosestStores(results) {
        const nearby = [];

        results.forEach((result, index) => {
            if (result.status === 'OK') {
                nearby.push({
                    store: window.HOVER_STORES[index],
                    distance: result.distance
                })
            }
        });

        return nearby.sort((a, b) => {
            return a.distance.value - b.distance.value
        }).slice(0, 3);
    }
})();
